define('v3/Common/Services/Backend/chatBackend',[
	'jquery',
	'BackendBase'
], function ($, BackendBase) {
	function ChatBackend () {
		BackendBase.call(this);
	};

	ChatBackend.prototype = $.extend({}, BackendBase.prototype);

	$.extend(ChatBackend.prototype, {
		createChat: function (classId, className) {
			return this._postJsonApiWithJwtAuthorization(Settings.chatApi + '/CreateChats/' + classId, { className: className }, { showError: false });
		},
		deleteChat: function (classId, pupilIds) {
			return this._deleteApiWithJwtAuthorization(Settings.chatApi + '/DeleteChats/' + classId, { userIds: pupilIds }, { dataType: 'text' });
		},
		deleteChannels: function (classId, users) {
			return this._deleteApiWithJwtAuthorization(Settings.chatApi + '/DeleteChannels/' + classId, { users: users }, { dataType: 'text' });
		},
		getActiveChatUsers: function () {
			return this._getJsonApiWithJwtAuthorization(Settings.chatApi + '/ListChats/');
		}
	});

	return new ChatBackend();
});

